import { IS_FORM_VALID, SET_ERRORS, SHOW_PORTFOLIO_DETAIL, GET_USERS, UPDATE_USER_TERRITORY, SET_USER_INFO } from '../actionTypes'
import { User } from '../reducers/user'

export const showPortfolioDetailAction = (showDetail: boolean) => ({ type: SHOW_PORTFOLIO_DETAIL, payload: showDetail })

export const changeFormValidity = (valid: boolean) => ({ type: IS_FORM_VALID, payload: valid })

export const setErrors = (errors: Record<string, boolean>) => ({ type: SET_ERRORS, payload: errors })

export const getUsersAction = (users: User[]) => ({type: GET_USERS, payload: users})

export const getUserAction = (user: User) => ({type: SET_USER_INFO, payload: {userId:user.id, user: user}})

export const updateUsersTerritoryAction = (user: User) => ({type: UPDATE_USER_TERRITORY, payload: user})